// @sync-with: calc-api/apps/agents/src/agents/tools/eval/proposeMetric.js

export const NAME_RE = /^[a-z][a-z0-9_]*$/

let metricIdSeq = 0

export function makeMetricId () {
  return `m_${(++metricIdSeq).toString(36)}_${Math.random().toString(36).slice(2, 6)}`
}

export function makeMetricRow (overrides = {}) {
  return {
    id: makeMetricId(),
    name: '',
    type: 'rating',
    description: '',
    weight: 1,
    ...overrides
  }
}

export function buildJudgeSpec (metrics) {
  const properties = {}
  const required = []
  const weights = {}
  const seen = new Set()

  for (const m of metrics || []) {
    const name = (m.name || '').trim()
    if (!name || !NAME_RE.test(name) || seen.has(name)) continue
    seen.add(name)

    const desc = (m.description || '').trim() || undefined
    properties[name] = m.type === 'passfail'
      ? { type: 'boolean', ...(desc && { description: desc }) }
      : { type: 'number', minimum: 1, maximum: 5, ...(desc && { description: desc }) }
    required.push(name)

    const w = Number(m.weight)
    if (Number.isFinite(w) && w !== 1) weights[name] = w
  }

  properties.reasoning = { type: 'string', description: 'Brief justification for the scores.' }
  required.push('reasoning')

  return {
    schema: { type: 'object', required, properties },
    weights
  }
}

export function hasValidMetric (metrics) {
  return (metrics || []).some(m => m.name && NAME_RE.test(m.name))
}
